/* Stil Reform – Drawer MVP (capture + submit) */
(() => {
  console.log('SR DRAWER JS LOADED ✅');
  const SELECTOR_ATC = 'button[name="add"].add-to-cart-button, button[name="add"][type="submit"]';

  let pending = null;   // { button, form, drawerRoot }
  let allowNextSubmit = false;
  // --- SR Add-ons (variant IDs) ---
const EXTRA_HOLE_VARIANT_ID   = 53401654624589;
const EXTRA_BUTTON_VARIANT_ID = 53401754927437;
const INNERFODER_VARIANT_ID   = 53448647704909; // +199 kr / plagg med innerfoder
const KORTNING_BRA_VARIANT_ID = 53076155138381; // 349 kr

// --- SR Packages (variant IDs) ---
const SR_LAGNING_BY_COUNT = {
  1: 53041437966669, // Lagning Bra
  3: 53041437999437, // Lagning Bättre
  5: 53041438032205  // Lagning Bäst
};

const SR_KORTNING_BY_COUNT = {
  1: 53076155138381, // Kortning Bra (349)
  3: 53076155171149, // Kortning Bättre
  5: 53076155203917  // Kortning Bäst
};

// Kortning som add-on per plagg (349 kr styck)
const SR_KORTNING_ADDON_VARIANT_ID = SR_KORTNING_BY_COUNT[1];

function srNormalizeCount(n){
  const x = Number(n) || 1;
  if (x <= 1) return 1;
  if (x <= 3) return 3;
  return 5;
}
function srCountFromVariantId(variantId) {
  const vid = Number(variantId);
  if (!vid) return 0;

  // LAGNING
  for (const [count, id] of Object.entries(SR_LAGNING_BY_COUNT)) {
    if (Number(id) === vid) return Number(count);
  }

  // KORTNING
  for (const [count, id] of Object.entries(SR_KORTNING_BY_COUNT)) {
    if (Number(id) === vid) return Number(count);
  }

  return 0;
}

function srCountFromVariantId(variantId) {
  const vid = Number(variantId);
  if (!vid) return 0;

  // LAGNING
  for (const [count, id] of Object.entries(SR_LAGNING_BY_COUNT)) {
    if (Number(id) === vid) return Number(count);
  }

  // KORTNING
  for (const [count, id] of Object.entries(SR_KORTNING_BY_COUNT)) {
    if (Number(id) === vid) return Number(count);
  }

  return 0;
}

function srGetSelectedValue(form, name) {
  const el = form.querySelector(`[name="${CSS.escape(name)}"]:checked`);
  return el ? el.value : '';
}

function srExtraQtyFromLabel(label) {
  if (!label) return 0;
  const n = parseInt(String(label), 10);
  if (Number.isNaN(n)) return 0;
  return Math.max(0, n - 1); // 1 ingår
}

async function srAddMainAndAddonsAndCheckout(p) {
  const form = p.form;
  const selectedVariantId =
  form?.querySelector('select[name="id"]')?.value ||
  form?.querySelector('input[name="id"][type="radio"]:checked')?.value ||
  form?.querySelector('input[name="id"]')?.value ||
  '';

  // Total plagg i paketet (1/3/5)
const totalGarments = srNormalizeCount(
  p.total || (Array.isArray(p.items) ? p.items.length : 1)
);

  // Collect properties[...] (efter strip finns oftast bara Sammanfattning + ev. Plaggbeskrivning)
  const fd = new FormData(form);
  const properties = {};
  for (const [k, v] of fd.entries()) {
    if (k.startsWith('properties[')) properties[k.replace(/^properties\[|\]$/g, '')] = v;
  }

  // --- Count add-ons from pending.items (NOT from form properties) ---
  const itemsData = Array.isArray(p.items) ? p.items : [];
  

  const toCount = (val) => {
    if (!val) return 0;
    const n = parseInt(String(val), 10);
    return Number.isNaN(n) ? 0 : n;
  };

  const hasAction = (it, actionLabel) => {
    const a = it.action ?? it.actions ?? it['Åtgärd'];
    if (Array.isArray(a)) return a.includes(actionLabel);
    if (typeof a === 'string') return a.split(',').map(s => s.trim()).includes(actionLabel) || a === actionLabel;
    return false;
  };

  let extraHolesQty = 0;
  let extraButtonsQty = 0;
  let hemmingQty = 0; // kortning-tillägg (om du vill)
  let innerfoderQty = 0; // +199 kr per plagg

  for (const it of itemsData) {
  // Hål: räkna om "Antal hål" finns (oavsett Åtgärd-text)
  const holesVal =
    it['Antal hål'] ?? it.holes ?? it.antal_hal ?? it.antalHål ?? '';

  const holesCount = toCount(holesVal);
  if (holesCount > 0) {
    extraHolesQty += Math.max(0, holesCount - 2); // 2 ingår
  }

  // Knappar: räkna om "Antal knappar" finns
  const btnVal =
    it['Antal knappar'] ?? it.buttons ?? it.antal_knappar ?? it.antalKnappar ?? '';

  const btnCount = toCount(btnVal);
  if (btnCount > 0) {
    extraButtonsQty += Math.max(0, btnCount - 0); // 0 ingår
  }

// Innerfoder: +199 kr om "Ja"
const liningVal = it['Innerfoder'] ?? it.innerfoder ?? it.lining ?? '';
if (String(liningVal).trim().toLowerCase() === 'ja') {
  innerfoderQty += 1;
}

 // Kortning avstängt i live (ska aldrig triggas)
hemmingQty += 0;
}


  // Avgör om ordern innehåller lagning (hål/knappar) och/eller kortning
const itemsDataSafe = Array.isArray(p.items) ? p.items : [];

const includesLagning = itemsDataSafe.some(it => {
  const a = it['Åtgärd'] ?? it.action ?? it.actions ?? '';
  const arr = Array.isArray(a) ? a : String(a).split(',').map(s => s.trim());
  return arr.includes('Laga hål') || arr.includes('Sy i knapp');
});

const includesKortning = hemmingQty > 0;

// Välj huvudprodukt:
// - Bara kortning => Kortning-paket
// - Lagning (eller mix) => Lagning-paket
const mainVariantId = Number(p.variantId);

if (!mainVariantId) {
  throw new Error('Missing main package variant id for totalGarments=' + totalGarments);
}

// Bygg varukorg
// Avgör vad kunden faktiskt valt
let hasRepair = false;  // Laga hål eller Sy i knapp

for (const it of itemsData) {
  const actionStr = String(it['Åtgärd'] ?? it.action ?? it.actions ?? '');
  if (actionStr.includes('Laga hål') || actionStr.includes('Sy i knapp')) {
    hasRepair = true;
    break;
  }
}

// Bygg cart items
const items = [];

// 1) Lägg bara till huvudprodukten (Lagning-variant) om repair finns
if (hasRepair) {
  items.push({ id: Number(mainVariantId), quantity: 1, properties });
} else {
  alert('Välj vad du vill få gjort.');
  return;
}

// 2) Add-ons (extra hål + extra knappar)
if (hasRepair) {
  if (extraHolesQty > 0)   items.push({ id: Number(EXTRA_HOLE_VARIANT_ID), quantity: extraHolesQty });
  if (extraButtonsQty > 0) items.push({ id: Number(EXTRA_BUTTON_VARIANT_ID), quantity: extraButtonsQty });
  if (innerfoderQty > 0) items.push({ id: Number(INNERFODER_VARIANT_ID), quantity: innerfoderQty });

  // Kortning är bortkopplad i live, så ingen rad här.
}
console.log('SR cart items sending ✅', { items, innerfoderQty, extraHolesQty, extraButtonsQty, itemsData });
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items })
  });

  if (!res.ok) {
    const t = await res.text();
    console.error('cart/add failed', t);
    alert('cart/add failed: ' + t);
    return;
  }

  setTimeout(() => { window.location.href = '/checkout'; }, 1500);
}



  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function openDrawer(drawerRoot) {// DEBUG: variant + counts
try {
  const countsRaw = drawerRoot.getAttribute('data-sr-variant-counts');
  console.log('SR counts raw:', countsRaw);

  const counts = countsRaw ? JSON.parse(countsRaw) : {};
  console.log('SR counts parsed:', counts);

  const forms = document.querySelectorAll('form[action^="/cart/add"]');
  console.log('SR forms found:', forms.length);

  forms.forEach((f, i) => {
    const v =
  f.querySelector('[name="id"]:checked')?.value ||
  f.querySelector('[name="id"]')?.value;
    console.log(`SR form ${i} variantId:`, v);
  });
} catch (e) {
  console.log('SR DEBUG ERROR', e);
}
// --- SR: set "Plagg 1 av X" based on selected variant ---
try {
  const countsRaw = drawerRoot.getAttribute('data-sr-variant-counts');
  const counts = countsRaw ? JSON.parse(countsRaw) : {};

const urlVariantId = new URLSearchParams(window.location.search).get('variant');

const form = pending?.form;
const formVariantId =
  form?.querySelector('select[name="id"]')?.value ||
  form?.querySelector('input[name="id"][type="radio"]:checked')?.value ||
  form?.querySelector('input[name="id"]')?.value; // hidden input (Shopify-standard)

const variantId = formVariantId || urlVariantId; // ✅ form vinner alltid
if (pending) pending.variantId = variantId;
console.log('SR variant used (drawer):', { formVariantId, urlVariantId, variantId });


  const totalFromVariant = srCountFromVariantId(variantId);



const total = totalFromVariant || 1;

console.log('SR TOTAL SOURCE ✅', { variantId, totalFromVariant, total });
  const elTotal = drawerRoot.querySelector('[data-sr-plagg-total]');
  const elIndex = drawerRoot.querySelector('[data-sr-plagg-index]');

  if (elTotal) elTotal.textContent = String(total);
  if (elIndex) elIndex.textContent = '1';
  // SR: init multi-garment loop state
if (pending) {
  pending.total = total;     // total plagg (t.ex. 3)
  pending.index = 1;         // startar på plagg 1
  pending.items = [];        // här sparar vi val per plagg
}

} catch (e) {}

    const overlay = qs(drawerRoot, '[data-sr-drawer-overlay]');
    const drawer = qs(drawerRoot, '[data-sr-drawer]');
    if (!overlay || !drawer) return;

    overlay.hidden = false;
drawer.hidden = false;

document.documentElement.classList.add('sr-drawer-open');
document.documentElement.style.overflow = 'hidden';// SR: progressive disclosure init
if (pending && pending.form) {
  // Reset ONLY drawer properties (do NOT touch paket/variant radios)
drawerRoot.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((i) => {
  if (i.name && i.name.startsWith('properties[')) {
    i.checked = false;
  }
});

// Reset text inputs inside drawer
drawerRoot.querySelectorAll(
  'textarea[name^="properties["], input[name^="properties["]'
).forEach((el) => {
  if (el.type !== 'radio' && el.type !== 'checkbox') {
    el.value = '';
  }
});

  updateDrawerFlow(drawerRoot, pending.form);
  // Ta bort Kortning helt i live
const shortLbl = drawerRoot.querySelector('[data-sr-action-shortening]');
if (shortLbl) {
  shortLbl.remove();
}


  showStep(drawerRoot, 'garment');
  hideStep(drawerRoot, 'action');
  hideStep(drawerRoot, 'holes');
  hideStep(drawerRoot, 'buttons');
  hideStep(drawerRoot, 'lining');

  setContinueEnabled(drawerRoot, false);
}



  }

  function closeDrawer(drawerRoot) {
    const overlay = qs(drawerRoot, '[data-sr-drawer-overlay]');
    const drawer = qs(drawerRoot, '[data-sr-drawer]');
    if (!overlay || !drawer) return;

    overlay.hidden = true;
drawer.hidden = true;

document.documentElement.classList.remove('sr-drawer-open');
document.documentElement.style.overflow = '';

  }

  function findDrawerRoot(fromEl) {
  // Returnera ALLTID ett element (aldrig document)
  return (
    fromEl.closest('[data-sr-drawer-root]') ||
    document.querySelector('[data-sr-drawer-root]')
  );
}


  function requireFields(form, drawerRoot) {
  // Always required
  const hasPlaggtyp = !!form.querySelector('input[name="properties[Plaggtyp]"]:checked');
  const hasAtgard  = !!form.querySelector('input[name="properties[Åtgärd]"]:checked');
  const hasLining  = !!form.querySelector('input[name="properties[Innerfoder]"]:checked');

  if (!hasPlaggtyp || !hasAtgard || !hasLining) return false;

  // Conditional required
  const selectedActions = Array.from(form.querySelectorAll('input[name="properties[Åtgärd]"]:checked'))
    .map(i => i.value);

  if (selectedActions.includes('Laga hål')) {
    const hasHoles = !!form.querySelector('input[name="properties[Antal hål]"]:checked');
    if (!hasHoles) return false;
  }

  if (selectedActions.includes('Sy i knapp')) {
    const hasButtons = !!form.querySelector('input[name="properties[Antal knappar]"]:checked');
    if (!hasButtons) return false;
  }

  // If lining is "Ja", still allow selection (UX note only). We’re not blocking checkout here.
  return true;
}
function setContinueEnabled(drawerRoot, enabled) {
  const btn = drawerRoot.querySelector('[data-sr-drawer-continue]');
  if (!btn) return;
  btn.toggleAttribute('disabled', !enabled);
  btn.classList.toggle('is-disabled', !enabled);
}

function showStep(drawerRoot, key) {
  const el = drawerRoot.querySelector(`.sr-step[data-sr-step="${key}"]`);
  if (el) el.hidden = false;

  // När sista riktiga steget visas → visa note
  if (key === 'lining') {
    const note = drawerRoot.querySelector('.sr-step--note');
    if (note) note.hidden = false;
  }
}


function hideStep(drawerRoot, key) {
  const el = drawerRoot.querySelector(`.sr-step[data-sr-step="${key}"]`);
  if (el) el.hidden = true;
}

function scrollToStep(drawerRoot, key) {
  const el = drawerRoot.querySelector(`.sr-step[data-sr-step="${key}"]`);
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

function updateDrawerFlow(drawerRoot, form) {
  if (!drawerRoot || !form) return;
  srWireNoteAfterLining(drawerRoot);

  // 1) Always start by hiding everything (then reveal progressively)
  hideStep(drawerRoot, 'action');
  hideStep(drawerRoot, 'holes');
  hideStep(drawerRoot, 'buttons');
  hideStep(drawerRoot, 'lining');

  // 2) Read current values
  const garment = form.querySelector('input[name="properties[Plaggtyp]"]:checked')?.value || '';


  const actions = Array.from(form.querySelectorAll('input[name="properties[Åtgärd]"]:checked')).map(i => i.value);
  const lining = form.querySelector('input[name="properties[Innerfoder]"]:checked')?.value || '';


  // 3) Kortning only for Byxor/Jeans (hide completely)
const shorteningLabel = drawerRoot.querySelector('[data-sr-action-shortening]');
const shorteningInput = shorteningLabel?.querySelector('input[value="Kortning"]');

const allowsShortening = (garment === 'Byxor' || garment === 'Jeans');

if (shorteningLabel && shorteningInput) {
  if (!allowsShortening) {
    shorteningLabel.style.display = 'none';   // hide fully (no gap)
    shorteningInput.checked = false;
  } else {
    shorteningLabel.style.display = '';       // restore default
  }
}


  // 4) Progressive disclosure
  // Step 1 (garment) is always visible (you already have it visible)
  if (!garment) {
    setContinueEnabled(drawerRoot, false);
    return;
  }

  showStep(drawerRoot, 'action');

  if (actions.length === 0) {
    setContinueEnabled(drawerRoot, false);
    return;
  }

  // Conditional steps
  const needsHoles = actions.includes('Laga hål');
  const needsButtons = actions.includes('Sy i knapp');

  if (needsHoles) showStep(drawerRoot, 'holes');
  if (needsButtons) showStep(drawerRoot, 'buttons');

  // Show lining last (always required)
  // Only show lining when conditional steps are satisfied (so it truly feels 1-at-a-time)
const holesOk = !needsHoles || !!form.querySelector('input[name="properties[Antal hål]"]:checked');
const buttonsOk = !needsButtons || !!form.querySelector('input[name="properties[Antal knappar]"]:checked');

  if (holesOk && buttonsOk) {
    showStep(drawerRoot, 'lining');
  }

  // Innerfoder note
  const liningNote = drawerRoot.querySelector('[data-sr-lining-note]');
  if (liningNote) liningNote.hidden = (lining !== 'Ja');

  // 5) Enable continue only when all required are selected
  setContinueEnabled(drawerRoot, requireFields(form, drawerRoot));
}
/* ===== SR: Multi-garment helpers ===== */

// SR: capture current garment selections (only the drawer properties)
function srCaptureGarment(form) {
  const data = {};
  const fd = new FormData(form);

  for (const [k, v] of fd.entries()) {
    if (typeof k === 'string' && k.startsWith('properties[')) {
      const key = k.slice('properties['.length, -1);

      // Om samma key kommer flera gånger (checkboxar) -> gör array
      if (data[key] === undefined) {
        data[key] = v;
      } else if (Array.isArray(data[key])) {
        data[key].push(v);
      } else {
        data[key] = [data[key], v];
      }
    }
  }
  return data;
}

// SR: reset all drawer inputs for next garment
function srResetDrawerInputs(form) {
  form.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(i => {
    i.checked = false;
  });

// Reset textfält (Plaggbeskrivning)
  form.querySelectorAll(
    'textarea[name="properties[Plaggbeskrivning]"], input[name="properties[Plaggbeskrivning]"]'
  ).forEach(el => {
    el.value = '';
  });
}

// SR: set/update a hidden line-item property on the form
function srSetHiddenProperty(form, key, value) {
 

  const name = `properties[${key}]`;
  let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.appendChild(input);
  }
  input.value = value;
}
function srBuildSummary(items) {
  return items.map((it, idx) => {
    const lines = [];

    const plaggtyp = it['Plaggtyp'] || 'Plagg';

    let atg = it['Åtgärd'] || [];
    if (typeof atg === 'string') atg = [atg];

    const holesN = it['Antal hål'] ? Number(it['Antal hål']) : null;
    const buttonsN = it['Antal knappar'] ? Number(it['Antal knappar']) : null;
    const innerfoder = it['Innerfoder'] || '';
    const desc =
      it['Plaggbeskrivning'] ||
      it['Beskrivning'] ||
      '';

    lines.push(`Plagg ${idx + 1}`);
    lines.push(`Plaggtyp: ${plaggtyp}`);

    if (atg.length) {
      lines.push(`Åtgärd: ${atg.join(', ')}`);
    }

    if (atg.includes('Laga hål') && holesN) {
      lines.push(`Antal hål: ${holesN}`);
    }

    if (atg.includes('Sy i knapp') && buttonsN) {
      lines.push(`Antal knappar: ${buttonsN}`);
    }

    if (innerfoder) {
      lines.push(`Innerfoder: ${innerfoder}`);
    }

    if (desc && String(desc).trim()) {
      lines.push(`Beskrivning: ${String(desc).trim()}`);
    }

    return lines.join('\n');
  }).join('\n\n---\n\n');
}

function srStripPerGarmentProperties(form) {
  const keep = new Set(['properties[Sammanfattning]', 'properties[_Plaggdata]']);

  form.querySelectorAll('input[name^="properties["]').forEach((el) => {
    const name = el.getAttribute('name');
    if (!name) return;
    if (keep.has(name)) return;
    el.removeAttribute('name');
  });
}

function srGetProductForm(btn) {
  // Försök hålla oss nära produktsidan först
  const scope = btn.closest('[data-section-id], main, .product') || document;

  const forms = Array.from(scope.querySelectorAll('form[action^="/cart/add"]'));

  // Välj den form som har variantväljare (select eller radio)
  const withPicker = forms.find(f =>
    f.querySelector('select[name="id"]') ||
    f.querySelector('input[name="id"][type="radio"]')
  );

  return withPicker || forms[0] || btn.closest('form');
}

  // 1) Fånga klicket före temats handlers (CAPTURE!)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest(SELECTOR_ATC);
    if (!btn) return;

    const form = srGetProductForm(btn);
if (!form) return;

    // Om vi “tillåter” nästa submit (efter Fortsätt) – släpp igenom
    if (allowNextSubmit) return;

    // Stoppa theme från att add-to-carta direkt
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    const drawerRoot = findDrawerRoot(btn);

    pending = { button: btn, form, drawerRoot };
    openDrawer(drawerRoot);
  }, true);

  // 2) Drawer actions
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('[data-sr-drawer-close]');
    const overlay = e.target.closest('[data-sr-drawer-overlay]');
    const cancelBtn = e.target.closest('[data-sr-drawer-cancel]');
    const continueBtn = e.target.closest('[data-sr-drawer-continue]');

    if (closeBtn || overlay || cancelBtn) {
      const root = e.target.closest('[data-sr-drawer-root]') || (pending && pending.drawerRoot);
      if (root) closeDrawer(root);
      pending = null;
      return;
    }

    if (continueBtn) {
      // STOPPA att Fortsätt råkar submit:a produktformuläret (som annars lägger till Lagning)
e.preventDefault();
e.stopPropagation();
if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      if (!pending) return;

       // Validera: knappen ska ändå vara disabled tills allt är klart
      if (!requireFields(pending.form, pending.drawerRoot)) {
        return;
      }


      // SR: multi-garment loop (no back, MVP)

// 1) Ensure loop state exists (fallback-safe)
if (!pending.items) pending.items = [];
if (!pending.total) {
  const elTotal = pending.drawerRoot.querySelector('[data-sr-plagg-total]');
  pending.total = elTotal ? Number(elTotal.textContent || '1') : 1;
}
if (!pending.index) pending.index = 1;

// 2) Save this garment's selections
const snapshot = srCaptureGarment(pending.form);
pending.items.push(snapshot);

// 3) If more garments remain → advance to next garment inside the drawer
if (pending.index < pending.total) {
  pending.index += 1;

  // Update "Plagg X av Y"
  const elIndex = pending.drawerRoot.querySelector('[data-sr-plagg-index]');
  if (elIndex) elIndex.textContent = String(pending.index);

  // Reset inputs for next garment + restart flow at garment step
  srResetDrawerInputs(pending.form);
  updateDrawerFlow(pending.drawerRoot, pending.form);

  showStep(pending.drawerRoot, 'garment');
  hideStep(pending.drawerRoot, 'action');
  hideStep(pending.drawerRoot, 'holes');
  hideStep(pending.drawerRoot, 'buttons');
  hideStep(pending.drawerRoot, 'lining');

  setContinueEnabled(pending.drawerRoot, false);
  scrollToStep(pending.drawerRoot, 'garment');
  return;
}

// 4) Last garment → store all garments on the main line item and submit
srSetHiddenProperty(pending.form, '_Plaggdata', JSON.stringify(pending.items));
srSetHiddenProperty(
  pending.form,
  'Sammanfattning',
  srBuildSummary(pending.items)
);
srStripPerGarmentProperties(pending.form);




// Now finish: close + add main + add-ons + checkout
closeDrawer(pending.drawerRoot);

// IMPORTANT: do NOT submit the form here (prevents double add)
allowNextSubmit = false;

console.log('SR FINISH CLICK ✅ pending:', pending);
srAddMainAndAddonsAndCheckout(pending).finally(() => {
  pending = null;
});

    }
  });
  // SR: react to selections (one step at a time)
document.addEventListener('change', (e) => {
  const root = e.target.closest('[data-sr-drawer-root]');
  if (!root) return;

  if (!pending || !pending.form) return;

  updateDrawerFlow(root, pending.form);

  const name = e.target.getAttribute('name');

  if (name === 'properties[Plaggtyp]') {
    showStep(root, 'action');
    scrollToStep(root, 'action');
  }

  if (name === 'properties[Åtgärd]') {
  // Visa nästa relevanta steg, men AUTO-SCROLLA INTE.
  // Detta gör att kunden hinner välja flera åtgärder utan att "tvingas vidare".
  const needsHoles = !!pending.form.querySelector('input[name="properties[Åtgärd]"][value="Laga hål"]:checked');
  const needsButtons = !!pending.form.querySelector('input[name="properties[Åtgärd]"][value="Sy i knapp"]:checked');

  if (needsHoles) showStep(root, 'holes');
  if (needsButtons) showStep(root, 'buttons');

  // Om inga antalsteg behövs kan vi visa lining, men utan scroll
  if (!needsHoles && !needsButtons) showStep(root, 'lining');

  return;
}

if (name === 'properties[Innerfoder]') {
  showStep(root, 'note');
  scrollToStep(root, 'note');
  return;
}


  if (name === 'properties[Antal hål]') {
    const needsButtons = !!pending.form.querySelector('input[name="properties[Åtgärd]"][value="Sy i knapp"]:checked');
    if (needsButtons) { showStep(root, 'buttons'); scrollToStep(root, 'buttons'); return; }
    showStep(root, 'lining');
    scrollToStep(root, 'lining');
  }

  if (name === 'properties[Antal knappar]') {
    showStep(root, 'lining');
    scrollToStep(root, 'lining');
  }
});

})();
// SR: Hide note step until lining is answered
function srWireNoteAfterLining(drawerRoot) {
  if (!drawerRoot) return;

  const liningStep = drawerRoot.querySelector('[data-sr-step="lining"]');
  const noteStep   = drawerRoot.querySelector('[data-sr-step="note"]');
  if (!liningStep || !noteStep) return;

  const liningInputs = liningStep.querySelectorAll('input[type="radio"], input[type="checkbox"]');

  const setNoteVisibility = () => {
    const answered = Array.from(liningInputs).some(i => i.checked);
    noteStep.hidden = !answered;
  };

  // initial state
  setNoteVisibility();

  // reveal once answered
  liningStep.addEventListener('change', (e) => {
    if (e.target && e.target.matches('input[type="radio"], input[type="checkbox"]')) {
      setNoteVisibility();
    }
  });
}
// SR: Show "note" only after "lining" is answered
(function srNoteAfterLining(){
  function wire(drawerRoot){
    const lining = drawerRoot.querySelector('[data-sr-step="lining"]');
    const note   = drawerRoot.querySelector('[data-sr-step="note"]');
    if (!lining || !note) return;

    // Avoid double-binding
    if (drawerRoot.__srNoteBound) return;
    drawerRoot.__srNoteBound = true;

    const inputs = () => Array.from(lining.querySelectorAll('input[type="radio"], input[type="checkbox"]'));
    const answered = () => inputs().some(i => i.checked);

    const sync = () => {
      const show = answered();
      note.hidden = !show;
      note.style.display = show ? '' : 'none'; // reliable even if other code toggles hidden
    };

    sync();
    lining.addEventListener('change', sync);
  }

  function findAndWire(){
    const drawerRoot = document.querySelector('.sr-drawer');
    if (drawerRoot) wire(drawerRoot);
  }

  // Run now + after Shopify/AJAX renders
  findAndWire();
  new MutationObserver(findAndWire).observe(document.documentElement, {childList:true, subtree:true});
})();